<template>
  <div class="event-list-container">
    <div
      v-for="d in data"
      :key="d.event_id"
      class="row ">
      <div v-show="!!getStatus(d)" :class="getStatusClass(d)">
          <span class="rotate">
            {{getStatus(d)}}
          </span>
      </div>
      <div :class="(!!getStatus(d) ? 'columns small-12 medium-8 reduce-40 event-info' : 'columns small-12 medium-8 event-info' )">
        <a class="event-type">
          {{decode(d.type_title)}}
        </a>
        <a
          :href="d.url"
          class="event-text-link">
          <h3 class="event-title">{{ d.title }}</h3>
          <p class="event-subtitle" v-if="!d.leader_line_1 && !!d.leader_name">with {{ d.leader_name }}</p>
          <p class="event-subtitle" v-if="!!d.leader_line_1">{{ d.leader_line_1 }}</p>
          <p class="event-subtitle-2" v-if="!!d.leader_line_2 && !!d.leader_line_1">{{ d.leader_line_2 }}</p>
          <p class="event-date">{{ d.date_range }}</p>
          <p>&nbsp;</p>
          <p class="event-short-desc">{{ decode(d.short_description) }}</p>
        </a>
      </div>
      <div class="columns small-12 medium-3 text-right event-more">
        <a
          :href="d.url"
          class="button">See Details</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getConfig, decodeHTML } from "../../utils/index.js";
let sComponents = {};

export default {
  name: "List",
  components: sComponents,
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      // counter: 0
    };
  },
  watch: {},
  mounted: function() {},
  updated: function() {},
  methods: {
    getStatusClass: function(event){
      let c = "columns medium-1 status "
      if(!!event.custom_button){
        return c + "custom-button";
      }else{
        return c + this.getStatus(event).toLowerCase().replace(/ /g, "-");
      }

    },
    getStatus: function(event){
      let status = ""
      if(event.available === 0){
        status = "Unavailable"
      }
      if(event.waiting_list === 1){
        status = "Waiting List"
      }
      if(!!event.custom_button){
        status = event.custom_button;
      }
      return status
    },
    decode: function(html){
      return decodeHTML(html)
    }
    // detailPage: function(event_id) {
    //   return getConfig("detail") + event_id;
    // }
  }
};
</script>
<style lang="scss" scoped>
.event-list-container{
    min-height: 250px;
    .status{
      position: relative;
      max-width: 40px;
      border-radius: 0 10px 10px 0;
      margin: 10px 0;
      .rotate{
        transform: translateX(-50%) translateY(-50%) rotate(-90deg);
        -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
        -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
        -ms-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
        -o-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
        position: absolute;
        white-space: nowrap;
        top: 50%;
        bottom: 50%;
        color: #fff;
        height: 18px;
        font-size: 17px;
        opacity: .8
      }
    }
    .reduce-40{
      flex: 0 0 calc(66.66% - 40px);
    }
    .custom-button{
      background-color: #b77e46;
    }
    .waiting-list{
      background-color: #777;
    }
    .unavailable, .sold-out{
      background-color: #C45C41;
    }

    a.event-text-link:active, a.event-text-link:visited{
      color: #63594e;
    }
    a.event-text-link:hover, a.event-text-link:focus{
      color: #3c372e;
    }
    .event-more{
      a.button{
        font-size: 1.1rem;
        border: 1px solid #b77e46;
        background: #fff;
        color: #b77e46;
        font-weight: 300;
        text-transform: uppercase;
        padding: 1.1rem 1.1rem;
        width: 100%;
      }

      a.button:active, a.button:visited{
        background: #fff;
        color: #b77e46;
      }
      a.button:hover, .a.button:focus{
        background-color: #926538;
        color: #fff;
      }

      // If Larger than Mobile
      @media screen and (min-width: 40em){
        margin-top: 1rem;
        a.button{
          width: auto;
          padding: 1.2rem 1.2rem;
        }
        // .event-short-desc{
        //   white-space: nowrap;
        //   overflow: hidden;
        //   text-overflow: ellipsis
        // }
      }
    }
    p {
      margin:0 !important;
    }
    .event-type{
      color: #a89c8f;
      text-transform: uppercase;
      font-weight: 700;
      font-size: .85rem;
      letter-spacing: 3px;
      margin-bottom: .75rem;
      display: block;
    }
    .event-title{}
    .event-subtitle{
      font-weight: 700;
      font-size: 1.1rem;
    }
    .event-subtitle-2{
      font-weight: 400;
    }
    .event-date{
      font-family: "proxima-nova",sans-serif;
      margin-bottom: 0.25rem;
    }

    @media screen and (min-width: 40em){
      // .event-short-desc{
      //   white-space: nowrap;
      //   overflow: hidden;
      //   text-overflow: ellipsis
      // }
    }

  }
</style>
